var _path, _path2, _path3, _path4, _path5, _path6, _stop, _stop2, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgOverloaded(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id2, ")")
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.042 15.397a14.537 14.537 0 00-8.204-6.964 15.592 15.592 0 00-19.477 9.08 14.458 14.458 0 00-.421 9.4 2.99 2.99 0 001.645 1.874 3.1 3.1 0 002.575 0 3.076 3.076 0 001.63-3.649 8.413 8.413 0 01.274-5.404 9.483 9.483 0 0111.793-5.516 8.391 8.391 0 014.959 4.405l.557 1.19 3.759-1.74a1.966 1.966 0 001.126-1.926 1.932 1.932 0 00-.216-.75z",
    fill: "url(#".concat(_id, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.98 15.77L23.81 20.045a1.5 1.5 0 00-.837 2.178l1.03 1.781 1.028 1.781a1.5 1.5 0 002.304.366l10.29-9.27a.655.655 0 00-.644-1.111z",
    fill: "#79C8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.003 29.202a5.198 5.198 0 100-10.397 5.198 5.198 0 000 10.397z",
    fill: "#5994B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.101 3.923A20.892 20.892 0 0024.12 3c-11.406-.064-20.973 9.32-21.12 20.724a20.788 20.788 0 003.076 11.208A3.174 3.174 0 008.75 36.43h5.404a1.313 1.313 0 100-2.626h-5.05a1.132 1.132 0 01-.985-.551 18.069 18.069 0 01-2.494-9.293c.012-8.656 7.363-17.075 15.933-18.176A18.398 18.398 0 0142.372 24a18.194 18.194 0 01-2.495 9.253 1.135 1.135 0 01-.984.55h-5.051a1.314 1.314 0 100 2.628h5.423a3.15 3.15 0 002.676-1.498 21.018 21.018 0 00-11.84-31.01z",
    fill: "#79C8F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.038 42.454A2.55 2.55 0 0138.491 45H9.577a2.553 2.553 0 010-5.106H38.49a2.529 2.529 0 011.797.747 2.56 2.56 0 01.75 1.812z",
    fill: "#F28484"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.102 3.923L29.04 6.35a18.407 18.407 0 00-7.481-.566C12.99 6.885 5.638 15.304 5.626 23.96a18.069 18.069 0 002.495 9.293 1.132 1.132 0 00.984.55h5.05a1.314 1.314 0 110 2.628h-5.42a3.174 3.174 0 01-2.675-1.498 20.788 20.788 0 01-3.061-11.21C3.147 12.322 12.713 2.937 24.119 3c2.029.016 4.044.327 5.983.923z",
    fill: "#8CD7FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.462 39.895L21.324 45H9.577a2.553 2.553 0 010-5.106h13.885z",
    fill: "#FA9898"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 8.349,
    y1: 18.334,
    x2: 37.261,
    y2: 18.334,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADC98"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9898"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: _id2
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3 3)",
    d: "M0 0h42v42H0z"
  })))));
}
export default SvgOverloaded;